import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../js/void.mjs';
import {
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
} from '../../js/numberConversion.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../exceptions.mjs';
import {
  toString1n9qg6fb0b5i8 as toString,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
} from '../../Char.mjs';
import { toString1h6jjoch8cjt8 as toString_0 } from '../../text/numberConversions.mjs';
import { toString1pkumu07cwy4m as toString_1 } from '../../js/coreRuntime.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../js/charSequenceJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  dividelr0uqtdj497z as divide,
  convertToInty04h231mmjoh as convertToInt,
} from '../../js/internal/longAsBigInt/longAsBigInt.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../text/StringBuilderJs.mjs';
import { Companion_instance2ztfx9zvq7j5d as Companion_instance } from '../../collections/AbstractList.mjs';
import { fill2542d4m9l93pn as fill } from '../../collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_base64EncodeMap() {
  _init_properties_Base64_kt__ymmsz3();
  return base64EncodeMap;
}
var base64EncodeMap;
function get_base64DecodeMap() {
  _init_properties_Base64_kt__ymmsz3();
  return base64DecodeMap;
}
var base64DecodeMap;
function get_base64UrlEncodeMap() {
  _init_properties_Base64_kt__ymmsz3();
  return base64UrlEncodeMap;
}
var base64UrlEncodeMap;
function get_base64UrlDecodeMap() {
  _init_properties_Base64_kt__ymmsz3();
  return base64UrlDecodeMap;
}
var base64UrlDecodeMap;
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  PaddingOption_PRESENT_instance = new (PaddingOption())('PRESENT', 0);
  PaddingOption_ABSENT_instance = new (PaddingOption())('ABSENT', 1);
  PaddingOption_PRESENT_OPTIONAL_instance = new (PaddingOption())('PRESENT_OPTIONAL', 2);
  PaddingOption_ABSENT_OPTIONAL_instance = new (PaddingOption())('ABSENT_OPTIONAL', 3);
}
var PaddingOption_PRESENT_instance;
var PaddingOption_ABSENT_instance;
var PaddingOption_PRESENT_OPTIONAL_instance;
var PaddingOption_ABSENT_OPTIONAL_instance;
var PaddingOptionClass;
function PaddingOption() {
  if (PaddingOptionClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'PaddingOption');
    PaddingOptionClass = $;
  }
  return PaddingOptionClass;
}
function shouldPadOnEncode($this) {
  return $this.paddingOption_1.equals(PaddingOption_PRESENT_getInstance()) || $this.paddingOption_1.equals(PaddingOption_PRESENT_OPTIONAL_getInstance());
}
function decodeImpl($this, source, destination, destinationOffset, startIndex, endIndex) {
  var decodeMap = $this.isUrlSafe_1 ? get_base64UrlDecodeMap() : get_base64DecodeMap();
  var payload = 0;
  var byteStart = -8;
  var sourceIndex = startIndex;
  var destinationIndex = destinationOffset;
  var hasPadding = false;
  $l$loop_1: while (sourceIndex < endIndex) {
    if (byteStart === -8 && (sourceIndex + 3 | 0) < endIndex) {
      var _unary__edvuaz = sourceIndex;
      sourceIndex = _unary__edvuaz + 1 | 0;
      var symbol1 = decodeMap[source[_unary__edvuaz] & 255];
      var _unary__edvuaz_0 = sourceIndex;
      sourceIndex = _unary__edvuaz_0 + 1 | 0;
      var symbol2 = decodeMap[source[_unary__edvuaz_0] & 255];
      var _unary__edvuaz_1 = sourceIndex;
      sourceIndex = _unary__edvuaz_1 + 1 | 0;
      var symbol3 = decodeMap[source[_unary__edvuaz_1] & 255];
      var _unary__edvuaz_2 = sourceIndex;
      sourceIndex = _unary__edvuaz_2 + 1 | 0;
      var symbol4 = decodeMap[source[_unary__edvuaz_2] & 255];
      var bits = symbol1 << 18 | symbol2 << 12 | symbol3 << 6 | symbol4;
      if (bits >= 0) {
        var _unary__edvuaz_3 = destinationIndex;
        destinationIndex = _unary__edvuaz_3 + 1 | 0;
        destination[_unary__edvuaz_3] = toByte(bits >> 16);
        var _unary__edvuaz_4 = destinationIndex;
        destinationIndex = _unary__edvuaz_4 + 1 | 0;
        destination[_unary__edvuaz_4] = toByte(bits >> 8);
        var _unary__edvuaz_5 = destinationIndex;
        destinationIndex = _unary__edvuaz_5 + 1 | 0;
        destination[_unary__edvuaz_5] = toByte(bits);
        continue $l$loop_1;
      }
      sourceIndex = sourceIndex - 4 | 0;
    }
    var symbol = source[sourceIndex] & 255;
    var symbolBits = decodeMap[symbol];
    if (symbolBits < 0) {
      if (symbolBits === -2) {
        hasPadding = true;
        sourceIndex = handlePaddingSymbol($this, source, sourceIndex, endIndex, byteStart);
        break $l$loop_1;
      } else if ($this.isMimeScheme_1) {
        sourceIndex = sourceIndex + 1 | 0;
        continue $l$loop_1;
      } else {
        throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$("Invalid symbol '" + toString(numberToChar(symbol)) + "'(" + toString_0(symbol, 8) + ') at index ' + sourceIndex);
      }
    } else {
      sourceIndex = sourceIndex + 1 | 0;
    }
    payload = payload << 6 | symbolBits;
    byteStart = byteStart + 6 | 0;
    if (byteStart >= 0) {
      var _unary__edvuaz_6 = destinationIndex;
      destinationIndex = _unary__edvuaz_6 + 1 | 0;
      destination[_unary__edvuaz_6] = toByte(payload >>> byteStart | 0);
      payload = payload & ((1 << byteStart) - 1 | 0);
      byteStart = byteStart - 8 | 0;
    }
  }
  if (byteStart === -2) {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('The last unit of input does not have enough bits');
  }
  if (!(byteStart === -8) && !hasPadding && $this.paddingOption_1.equals(PaddingOption_PRESENT_getInstance())) {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('The padding option is set to PRESENT, but the input is not properly padded');
  }
  if (!(payload === 0)) {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('The pad bits must be zeros');
  }
  sourceIndex = skipIllegalSymbolsIfMime($this, source, sourceIndex, endIndex);
  if (sourceIndex < endIndex) {
    var symbol_0 = source[sourceIndex] & 255;
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$("Symbol '" + toString(numberToChar(symbol_0)) + "'(" + toString_0(symbol_0, 8) + ') at index ' + (sourceIndex - 1 | 0) + ' is prohibited after the pad character');
  }
  return destinationIndex - destinationOffset | 0;
}
function handlePaddingSymbol($this, source, padIndex, endIndex, byteStart) {
  var tmp;
  switch (byteStart) {
    case -8:
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Redundant pad character at index ' + padIndex);
    case -2:
      tmp = padIndex + 1 | 0;
      break;
    case -4:
      checkPaddingIsAllowed($this, padIndex);
      var secondPadIndex = skipIllegalSymbolsIfMime($this, source, padIndex + 1 | 0, endIndex);
      if (secondPadIndex === endIndex || !(source[secondPadIndex] === 61)) {
        throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Missing one pad character at index ' + secondPadIndex);
      }

      tmp = secondPadIndex + 1 | 0;
      break;
    case -6:
      checkPaddingIsAllowed($this, padIndex);
      tmp = padIndex + 1 | 0;
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'Unreachable';
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_1(message));
  }
  return tmp;
}
function checkPaddingIsAllowed($this, padIndex) {
  if ($this.paddingOption_1.equals(PaddingOption_ABSENT_getInstance())) {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('The padding option is set to ABSENT, but the input has a pad character at index ' + padIndex);
  }
}
function skipIllegalSymbolsIfMime($this, source, startIndex, endIndex) {
  if (!$this.isMimeScheme_1) {
    return startIndex;
  }
  var sourceIndex = startIndex;
  while (sourceIndex < endIndex) {
    var symbol = source[sourceIndex] & 255;
    if (!(get_base64DecodeMap()[symbol] === -1)) {
      return sourceIndex;
    }
    sourceIndex = sourceIndex + 1 | 0;
  }
  return sourceIndex;
}
function checkDestinationBounds($this, destinationSize, destinationOffset, capacityNeeded) {
  if (destinationOffset < 0 || destinationOffset > destinationSize) {
    throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('destination offset: ' + destinationOffset + ', destination size: ' + destinationSize);
  }
  var destinationEndIndex = destinationOffset + capacityNeeded | 0;
  if (destinationEndIndex < 0 || destinationEndIndex > destinationSize) {
    throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('The destination array does not have enough capacity, ' + ('destination offset: ' + destinationOffset + ', destination size: ' + destinationSize + ', capacity needed: ' + capacityNeeded));
  }
}
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Base64() {
      constructor() {
        Default_instance = null;
        super(false, false, -1, PaddingOption_PRESENT_getInstance());
        Default_instance = this;
        this.bitsPerByte_1 = 8;
        this.bitsPerSymbol_1 = 6;
        this.bytesPerGroup_1 = 3;
        this.symbolsPerGroup_1 = 4;
        this.padSymbol_1 = 61;
        this.lineLengthMime_1 = 76;
        this.lineLengthPem_1 = 64;
        var tmp = this;
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(13);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var tmp_0 = toByte(tmp$ret$0);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(10);
        var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
        // Inline function 'kotlin.byteArrayOf' call
        tmp.mimeLineSeparatorSymbols_1 = new Int8Array([tmp_0, toByte(tmp$ret$1)]);
        this.UrlSafe_1 = new (Base64())(true, false, -1, PaddingOption_PRESENT_getInstance());
        this.Mime_1 = new (Base64())(false, true, 76, PaddingOption_PRESENT_getInstance());
        this.Pem_1 = new (Base64())(false, true, 64, PaddingOption_PRESENT_getInstance());
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
function PaddingOption_PRESENT_getInstance() {
  static_init();
  return PaddingOption_PRESENT_instance;
}
function PaddingOption_ABSENT_getInstance() {
  static_init();
  return PaddingOption_ABSENT_instance;
}
function PaddingOption_PRESENT_OPTIONAL_getInstance() {
  static_init();
  return PaddingOption_PRESENT_OPTIONAL_instance;
}
function PaddingOption_ABSENT_OPTIONAL_getInstance() {
  static_init();
  return PaddingOption_ABSENT_OPTIONAL_instance;
}
var Base64Class;
function Base64() {
  if (Base64Class === VOID) {
    class $ {
      constructor(isUrlSafe, isMimeScheme, mimeLineLength, paddingOption) {
        Default_getInstance();
        this.isUrlSafe_1 = isUrlSafe;
        this.isMimeScheme_1 = isMimeScheme;
        this.mimeLineLength_1 = mimeLineLength;
        this.paddingOption_1 = paddingOption;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!(!this.isUrlSafe_1 || !this.isMimeScheme_1)) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString_1(message));
        }
        this.mimeGroupsPerLine_1 = this.mimeLineLength_1 / 4 | 0;
      }
      withPadding_845pcm_k$(option) {
        return this.paddingOption_1.equals(option) ? this : new (Base64())(this.isUrlSafe_1, this.isMimeScheme_1, this.mimeLineLength_1, option);
      }
      encode_hqs3g6_k$(source, startIndex, endIndex) {
        // Inline function 'kotlin.io.encoding.platformEncodeToString' call
        var byteResult = this.encodeToByteArrayImpl_2nw9xk_k$(source, startIndex, endIndex);
        return this.bytesToStringImpl_94yjtd_k$(byteResult);
      }
      encode$default_h4nonq_k$(source, startIndex, endIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? source.length : endIndex;
        return $super === VOID ? this.encode_hqs3g6_k$(source, startIndex, endIndex) : $super.encode_hqs3g6_k$.call(this, source, startIndex, endIndex);
      }
      decode_iptc9a_k$(source, startIndex, endIndex) {
        this.checkSourceBounds_fk7x94_k$(source.length, startIndex, endIndex);
        var decodeSize = this.decodeSize_c4ofgn_k$(source, startIndex, endIndex);
        var destination = new Int8Array(decodeSize);
        var bytesWritten = decodeImpl(this, source, destination, 0, startIndex, endIndex);
        // Inline function 'kotlin.check' call
        if (!(bytesWritten === destination.length)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        return destination;
      }
      decode$default_vlp1n6_k$(source, startIndex, endIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? source.length : endIndex;
        return $super === VOID ? this.decode_iptc9a_k$(source, startIndex, endIndex) : $super.decode_iptc9a_k$.call(this, source, startIndex, endIndex);
      }
      decode_lt35e9_k$(source, startIndex, endIndex) {
        // Inline function 'kotlin.io.encoding.platformCharsToBytes' call
        var byteSource = this.charsToBytesImpl_z1u042_k$(source, startIndex, endIndex);
        return this.decode$default_vlp1n6_k$(byteSource);
      }
      decode$default_mne14l_k$(source, startIndex, endIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? charSequenceLength(source) : endIndex;
        return $super === VOID ? this.decode_lt35e9_k$(source, startIndex, endIndex) : $super.decode_lt35e9_k$.call(this, source, startIndex, endIndex);
      }
      encodeToByteArrayImpl_2nw9xk_k$(source, startIndex, endIndex) {
        this.checkSourceBounds_fk7x94_k$(source.length, startIndex, endIndex);
        var encodeSize = this.encodeSize_ced6p5_k$(endIndex - startIndex | 0);
        var destination = new Int8Array(encodeSize);
        this.encodeIntoByteArrayImpl_agts2t_k$(source, destination, 0, startIndex, endIndex);
        return destination;
      }
      encodeIntoByteArrayImpl_agts2t_k$(source, destination, destinationOffset, startIndex, endIndex) {
        this.checkSourceBounds_fk7x94_k$(source.length, startIndex, endIndex);
        checkDestinationBounds(this, destination.length, destinationOffset, this.encodeSize_ced6p5_k$(endIndex - startIndex | 0));
        var encodeMap = this.isUrlSafe_1 ? get_base64UrlEncodeMap() : get_base64EncodeMap();
        var sourceIndex = startIndex;
        var destinationIndex = destinationOffset;
        var groupsPerLine = this.isMimeScheme_1 ? this.mimeGroupsPerLine_1 : 2147483647;
        while ((sourceIndex + 2 | 0) < endIndex) {
          // Inline function 'kotlin.comparisons.minOf' call
          var a = (endIndex - sourceIndex | 0) / 3 | 0;
          var groups = Math.min(a, groupsPerLine);
          var inductionVariable = 0;
          if (inductionVariable < groups)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var _unary__edvuaz = sourceIndex;
              sourceIndex = _unary__edvuaz + 1 | 0;
              var byte1 = source[_unary__edvuaz] & 255;
              var _unary__edvuaz_0 = sourceIndex;
              sourceIndex = _unary__edvuaz_0 + 1 | 0;
              var byte2 = source[_unary__edvuaz_0] & 255;
              var _unary__edvuaz_1 = sourceIndex;
              sourceIndex = _unary__edvuaz_1 + 1 | 0;
              var byte3 = source[_unary__edvuaz_1] & 255;
              var bits = byte1 << 16 | byte2 << 8 | byte3;
              var _unary__edvuaz_2 = destinationIndex;
              destinationIndex = _unary__edvuaz_2 + 1 | 0;
              destination[_unary__edvuaz_2] = encodeMap[bits >>> 18 | 0];
              var _unary__edvuaz_3 = destinationIndex;
              destinationIndex = _unary__edvuaz_3 + 1 | 0;
              destination[_unary__edvuaz_3] = encodeMap[(bits >>> 12 | 0) & 63];
              var _unary__edvuaz_4 = destinationIndex;
              destinationIndex = _unary__edvuaz_4 + 1 | 0;
              destination[_unary__edvuaz_4] = encodeMap[(bits >>> 6 | 0) & 63];
              var _unary__edvuaz_5 = destinationIndex;
              destinationIndex = _unary__edvuaz_5 + 1 | 0;
              destination[_unary__edvuaz_5] = encodeMap[bits & 63];
            }
             while (inductionVariable < groups);
          if (groups === groupsPerLine && !(sourceIndex === endIndex)) {
            var _unary__edvuaz_6 = destinationIndex;
            destinationIndex = _unary__edvuaz_6 + 1 | 0;
            destination[_unary__edvuaz_6] = Default_getInstance().mimeLineSeparatorSymbols_1[0];
            var _unary__edvuaz_7 = destinationIndex;
            destinationIndex = _unary__edvuaz_7 + 1 | 0;
            destination[_unary__edvuaz_7] = Default_getInstance().mimeLineSeparatorSymbols_1[1];
          }
        }
        var tmp0_subject = endIndex - sourceIndex | 0;
        if (tmp0_subject === 1) {
          var _unary__edvuaz_8 = sourceIndex;
          sourceIndex = _unary__edvuaz_8 + 1 | 0;
          var byte1_0 = source[_unary__edvuaz_8] & 255;
          var bits_0 = byte1_0 << 4;
          var _unary__edvuaz_9 = destinationIndex;
          destinationIndex = _unary__edvuaz_9 + 1 | 0;
          destination[_unary__edvuaz_9] = encodeMap[bits_0 >>> 6 | 0];
          var _unary__edvuaz_10 = destinationIndex;
          destinationIndex = _unary__edvuaz_10 + 1 | 0;
          destination[_unary__edvuaz_10] = encodeMap[bits_0 & 63];
          if (shouldPadOnEncode(this)) {
            var _unary__edvuaz_11 = destinationIndex;
            destinationIndex = _unary__edvuaz_11 + 1 | 0;
            destination[_unary__edvuaz_11] = 61;
            var _unary__edvuaz_12 = destinationIndex;
            destinationIndex = _unary__edvuaz_12 + 1 | 0;
            destination[_unary__edvuaz_12] = 61;
          }
        } else if (tmp0_subject === 2) {
          var _unary__edvuaz_13 = sourceIndex;
          sourceIndex = _unary__edvuaz_13 + 1 | 0;
          var byte1_1 = source[_unary__edvuaz_13] & 255;
          var _unary__edvuaz_14 = sourceIndex;
          sourceIndex = _unary__edvuaz_14 + 1 | 0;
          var byte2_0 = source[_unary__edvuaz_14] & 255;
          var bits_1 = byte1_1 << 10 | byte2_0 << 2;
          var _unary__edvuaz_15 = destinationIndex;
          destinationIndex = _unary__edvuaz_15 + 1 | 0;
          destination[_unary__edvuaz_15] = encodeMap[bits_1 >>> 12 | 0];
          var _unary__edvuaz_16 = destinationIndex;
          destinationIndex = _unary__edvuaz_16 + 1 | 0;
          destination[_unary__edvuaz_16] = encodeMap[(bits_1 >>> 6 | 0) & 63];
          var _unary__edvuaz_17 = destinationIndex;
          destinationIndex = _unary__edvuaz_17 + 1 | 0;
          destination[_unary__edvuaz_17] = encodeMap[bits_1 & 63];
          if (shouldPadOnEncode(this)) {
            var _unary__edvuaz_18 = destinationIndex;
            destinationIndex = _unary__edvuaz_18 + 1 | 0;
            destination[_unary__edvuaz_18] = 61;
          }
        }
        // Inline function 'kotlin.check' call
        if (!(sourceIndex === endIndex)) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        return destinationIndex - destinationOffset | 0;
      }
      encodeSize_ced6p5_k$(sourceSize) {
        var groups = sourceSize / 3 | 0;
        var trailingBytes = sourceSize % 3 | 0;
        var size = imul(groups, 4);
        if (!(trailingBytes === 0)) {
          size = size + (shouldPadOnEncode(this) ? 4 : trailingBytes + 1 | 0) | 0;
        }
        if (size < 0) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Input is too big');
        }
        if (this.isMimeScheme_1) {
          size = size + imul((size - 1 | 0) / this.mimeLineLength_1 | 0, 2) | 0;
        }
        if (size < 0) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Input is too big');
        }
        return size;
      }
      decodeSize_c4ofgn_k$(source, startIndex, endIndex) {
        var symbols = endIndex - startIndex | 0;
        if (symbols === 0) {
          return 0;
        }
        if (symbols === 1) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Input should have at least 2 symbols for Base64 decoding, startIndex: ' + startIndex + ', endIndex: ' + endIndex);
        }
        if (this.isMimeScheme_1) {
          var inductionVariable = startIndex;
          if (inductionVariable < endIndex)
            $l$loop: do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var symbol = source[index] & 255;
              var symbolBits = get_base64DecodeMap()[symbol];
              if (symbolBits < 0) {
                if (symbolBits === -2) {
                  symbols = symbols - (endIndex - index | 0) | 0;
                  break $l$loop;
                }
                symbols = symbols - 1 | 0;
              }
            }
             while (inductionVariable < endIndex);
        } else if (source[endIndex - 1 | 0] === 61) {
          symbols = symbols - 1 | 0;
          if (source[endIndex - 2 | 0] === 61) {
            symbols = symbols - 1 | 0;
          }
        }
        // Inline function 'kotlin.Long.times' call
        var this_0 = fromInt(symbols);
        // Inline function 'kotlin.Long.div' call
        var this_1 = multiply(this_0, fromInt(6));
        var tmp$ret$1 = divide(this_1, fromInt(8));
        return convertToInt(tmp$ret$1);
      }
      charsToBytesImpl_z1u042_k$(source, startIndex, endIndex) {
        this.checkSourceBounds_fk7x94_k$(charSequenceLength(source), startIndex, endIndex);
        var byteArray = new Int8Array(endIndex - startIndex | 0);
        var length = 0;
        var inductionVariable = startIndex;
        if (inductionVariable < endIndex)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.code' call
            var this_0 = charSequenceGet(source, index);
            var symbol = Char__toInt_impl_vasixd(this_0);
            if (symbol <= 255) {
              var _unary__edvuaz = length;
              length = _unary__edvuaz + 1 | 0;
              byteArray[_unary__edvuaz] = toByte(symbol);
            } else {
              var _unary__edvuaz_0 = length;
              length = _unary__edvuaz_0 + 1 | 0;
              byteArray[_unary__edvuaz_0] = 63;
            }
          }
           while (inductionVariable < endIndex);
        return byteArray;
      }
      bytesToStringImpl_94yjtd_k$(source) {
        var stringBuilder = StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(source.length);
        var inductionVariable = 0;
        var last = source.length;
        while (inductionVariable < last) {
          var byte = source[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          stringBuilder.append_58al37_k$(numberToChar(byte));
        }
        return stringBuilder.toString();
      }
      checkSourceBounds_fk7x94_k$(sourceSize, startIndex, endIndex) {
        Companion_instance.checkBoundsIndexes_tsopv1_k$(startIndex, endIndex, sourceSize);
      }
    }
    initMetadataForClass($, 'Base64');
    Base64Class = $;
  }
  return Base64Class;
}
var properties_initialized_Base64_kt_5g824v;
function _init_properties_Base64_kt__ymmsz3() {
  if (!properties_initialized_Base64_kt_5g824v) {
    properties_initialized_Base64_kt_5g824v = true;
    // Inline function 'kotlin.byteArrayOf' call
    base64EncodeMap = new Int8Array([65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 47]);
    // Inline function 'kotlin.apply' call
    var this_0 = new Int32Array(256);
    fill(this_0, -1);
    this_0[61] = -2;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = get_base64EncodeMap();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      this_0[item] = _unary__edvuaz;
    }
    base64DecodeMap = this_0;
    // Inline function 'kotlin.byteArrayOf' call
    base64UrlEncodeMap = new Int8Array([65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 45, 95]);
    // Inline function 'kotlin.apply' call
    var this_1 = new Int32Array(256);
    fill(this_1, -1);
    this_1[61] = -2;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index_0 = 0;
    var indexedObject_0 = get_base64UrlEncodeMap();
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var _unary__edvuaz_0 = index_0;
      index_0 = _unary__edvuaz_0 + 1 | 0;
      this_1[item_0] = _unary__edvuaz_0;
    }
    base64UrlDecodeMap = this_1;
  }
}
//region block: exports
export {
  PaddingOption_ABSENT_OPTIONAL_getInstance as PaddingOption_ABSENT_OPTIONAL_getInstanceopa392vnv2j4,
  Default_getInstance as Default_getInstance3483fw4bkmewo,
};
//endregion

//# sourceMappingURL=Base64.mjs.map
